import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { KeyboardArrowUp as ArrowUpIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

const GoToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  useEffect(() => {
    const toggleVisibility = () => {
      // Show when scrolled past the hero section (approximately 100vh)
      if (window.pageYOffset > window.innerHeight * 0.8) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        position: 'fixed',
        bottom: 40,
        left: '50%',
        transform: 'translateX(-50%)',
        cursor: 'pointer',
        zIndex: 1000,
      }}
      onClick={scrollToTop}
    >
      <motion.div
        animate={{ y: [0, 12, 0] }}
        transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: isDark ? 'rgba(255,255,255,0.8)' : 'rgba(255, 255, 255, 0.8)',
              fontWeight: 500,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              fontFamily: '"Roboto Mono", "Courier New", monospace',
            }}
          >
            Go to Top
          </Typography>
          <ArrowUpIcon
            sx={{
              fontSize: 32,
              color: isDark ? 'rgba(255,255,255,0.9)' : 'rgba(255, 255, 255, 0.9)',
              filter: isDark ? 'drop-shadow(0 2px 4px #000)' : 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
            }}
          />
        </Box>
      </motion.div>
    </motion.div>
  );
};

export default GoToTopButton; 